let th = {
    home: {
      "hello": "สวัสดี"
    },
    footer: {
      "address": "ที่อยู่"
    }
  };
  
  export default th;